<template>
  <div class="about-view">
    <v-card class="glass-card pa-8 pa-md-12 text-center mb-8">
      <div class="about-brand-badge mb-4 mx-auto">
        <v-icon size="40" color="primary">mdi-filmstrip-box</v-icon>
      </div>
      <h1 class="text-h3 font-weight-bold mb-3">Media Catalog</h1>
      <p class="text-subtitle-1 text-medium-emphasis max-w-md mx-auto mb-6">
        A unified personal multimedia catalog designed for seamlessly organizing, tracking, and discovering Movies, Books, Audiobooks, and Comics.
      </p>

      <div class="d-flex justify-center flex-wrap ga-2 mb-8">
        <v-chip color="#6366f1" variant="flat" class="text-white font-weight-bold">
          <v-icon start size="16">mdi-movie-open</v-icon> Movies
        </v-chip>
        <v-chip color="#10b981" variant="flat" class="text-white font-weight-bold">
          <v-icon start size="16">mdi-book-open-page-variant</v-icon> Books
        </v-chip>
        <v-chip color="#f43f5e" variant="flat" class="text-white font-weight-bold">
          <v-icon start size="16">mdi-headphones</v-icon> Audiobooks
        </v-chip>
        <v-chip color="#f59e0b" variant="flat" class="text-white font-weight-bold">
          <v-icon start size="16">mdi-draw</v-icon> Comics & Manga
        </v-chip>
      </div>

      <v-divider class="mb-8" />

      <v-row>
        <v-col cols="12" sm="4">
          <div class="feature-highlight pa-4 rounded-xl">
            <v-icon size="32" color="primary" class="mb-2">mdi-sparkles</v-icon>
            <div class="text-subtitle-2 font-weight-bold">Smart Auto-Fill</div>
            <div class="text-caption text-medium-emphasis">Integrated with TMDB and Google Books API for instantaneous metadata and poster autofill.</div>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="feature-highlight pa-4 rounded-xl">
            <v-icon size="32" color="success" class="mb-2">mdi-view-carousel-outline</v-icon>
            <div class="text-subtitle-2 font-weight-bold">Shelf & Grid Views</div>
            <div class="text-caption text-medium-emphasis">Browse your collection across horizontal shelf carousels or responsive high-density poster grids.</div>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="feature-highlight pa-4 rounded-xl">
            <v-icon size="32" color="warning" class="mb-2">mdi-theme-light-dark</v-icon>
            <div class="text-subtitle-2 font-weight-bold">Obsidian & Light Themes</div>
            <div class="text-caption text-medium-emphasis">Engineered with a curated obsidian dark theme, fluid glassmorphic elevation, and persistent preferences.</div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AboutView',
}
</script>

<style scoped>
.about-view {
  max-width: 960px;
  margin: 0 auto;
  padding: 16px 0;
}

.about-brand-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 24px;
  background: rgba(99, 102, 241, 0.12);
  border: 1px solid rgba(99, 102, 241, 0.25);
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.2);
}

.feature-highlight {
  background: rgba(128, 128, 128, 0.05);
  border: 1px solid rgba(128, 128, 128, 0.1);
  height: 100%;
}

.max-w-md {
  max-width: 580px;
}
</style>

